import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "../../theme/customerTheme";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "../../contexts/AuthProvider";
import { GoldPriceProvider } from "../../contexts/GoldPriceProvider";
import { NotificationsProvider } from "../../contexts/NotificationsProvider";
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ModalContextProvider } from "../../contexts/ModalProvider";
import 'dayjs/locale/pt-br';

export default function ComponentProvider({ children }) {

    const queryClient = new QueryClient();

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
                <QueryClientProvider client={queryClient}>
                    <ModalContextProvider>
                        <BrowserRouter>
                            <AuthProvider>
                                <NotificationsProvider>
                                    <GoldPriceProvider>
                                        {children}
                                    </GoldPriceProvider>
                                </NotificationsProvider>
                            </AuthProvider>
                        </BrowserRouter>
                        <Toaster
                            position='top-center'
                            reverseOrder={false}
                            duration={3000}
                        />
                        <CssBaseline />
                    </ModalContextProvider>
                </QueryClientProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
};